export const isNullOrWhiteSpace = (input?: string | null) => {
    return input === null || input === undefined || input.trim().length === 0;
}